import React, { useState } from "react";
import { UploadSVG, MicSVG, EnquiryUploadSVG } from "../../assets/svg/allSvg";
import SoundRecorder from "../Home/AudioRecorder";
import ImgUploaded from "../../../src/assets/homepage/enquiry/Layer 2.jpg";
import {
  QuotationAddSVG,
  QuotationDeleteSVG,
} from "../../../src/assets/svg/allSvg";
import { rfqSubmitApi } from "../../../src/Apis/BuyerApi";
const QuotationForm = () => {
  const [requirements, setRequirements] = useState("");
  const [quantity, setQuantity] = useState("");
  const [unit, setUnit] = useState("Unit");
  const [orderValue, setOrderValue] = useState("");
  const [currency, setCurrency] = useState("Currency");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [type, setType] = useState("audio");
  const [attachments, setAttachments] = useState([]);
  const [files, setFiles] = useState([]);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [sendToMoreSuppliers, setSendToMoreSuppliers] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [selectedOption, setSelectedOption] = useState("recordRequirement");

  const quantities = [100, 200, 500, 800, 1000];

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic
  };

  const handleSubmitButtonClick = async () => {
    if (!phoneNumber || !amount || !quantity) {
      return;
    }

    let file = files;

    if (type == "audio") file = attachments;

    const data = {
      title,
      description,
      quantity,
      phoneNumber,
      amount,
      files: file,
      type,
    };

    await rfqSubmitApi(data);
  };


  const handleRadioBtnChange = (e) => {
    const optionSelected = e.target.value;
    setSelectedOption(optionSelected);

    const typeSelected =
      optionSelected === "recordRequirement" ? "audio" : "images";
    setType(typeSelected);
    setAttachments([]);
  };
  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    if (uploadedFiles.length + files.length <= 4) {
      const newFiles = files.map((file) => ({
        file,
        url: URL.createObjectURL(file),
      }));
      setUploadedFiles((prevFiles) => [...prevFiles, ...newFiles]);
    } else {
      alert("You can only upload up to 4 files.");
    }
  };
  function handleFiles(event) {
    const selectedFiles = Array.from(event.target.files);

    // Combine existing files with new selected files, removing duplicates and maintaining order
    const combinedFiles = [...files, ...selectedFiles].reduce((acc, file) => {
      if (!acc.find((f) => f.name === file.name)) {
        acc.push(file);
      } else {
        // Move existing file to the end if it was re-selected
        acc = acc.filter((f) => f.name !== file.name);
        acc.push(file);
      }
      return acc;
    }, []);

    const newFiles = combinedFiles.slice(-4);

    setFiles(newFiles.reverse());
  }

  function handleUpload(event) {
    event.preventDefault();
    if (files.length === 0) return;

    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append(files, { i }, files[i]);
    }

    fetch("url", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((result) => {
        console.log("success", result);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  function handleDrop(event) {
    event.preventDefault();
    const droppedFiles = Array.from(event.dataTransfer.files);

    const limitedFiles = droppedFiles.slice(0, 4 - files.length);
    setFiles([...files, ...limitedFiles]);
  }

  const handleOrderValueChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      // Allow only numeric values
      setAmount(value);
    }
  };
  const handlePhoneNumberChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setPhoneNumber(value);
    }
  };

  function handleDelete(index) {
    const newFiles = files.filter((_, i) => i !== index);
    setFiles(newFiles);
  }

  const handleDeleteFile = (index) => {
    setUploadedFiles((prevFiles) => {
      const updatedFiles = [...prevFiles];
      URL.revokeObjectURL(updatedFiles[index].url); // Revoke the object URL
      updatedFiles.splice(index, 1);
      return updatedFiles;
    });
  };

  return (
    <div className="max-w-[1240px] m-auto flex items-center justify-center h-[1132px]">
      <div className="w-[903px] h-[1032px] flex flex-col items-start">
        <h2 className="w-[223px] h-[30px] text-black font-semibold text-[20px]">
          Request for Quotation
        </h2>
        <hr className="w-[263px] h-[2px] rounded-[2px] bg-[#FF6300] mt-[10px]" />

        <div className="w-full h-[80px] rounded-[12px] bg-[#F1F1F1] flex flex-row mt-[24px] items-center justify-between px-[36px]">
          <div className="flex flex-row w-[202px] h-[48px] items-center justify-between">
            <p className="w-[24px] h-[24px] border border-black font-semibold text-[16px] flex items-center justify-center rounded-full">
              1
            </p>
            <p className="text-start text-black w-[170px] h-[48px] font-semibold text-[16px]">
              Submit a RFQ in Just 1 min
            </p>
          </div>

          <div className="flex flex-row w-[229px] h-[48px] items-center justify-between">
            <p className="w-[24px] h-[24px] border border-black font-semibold text-[16px] flex items-center justify-center rounded-full">
              2
            </p>
            <p className="text-start text-black w-[197px] h-[48px] font-semibold text-[16px]">
              Get multiple quotations from verified suppliers
            </p>
          </div>

          <div className="flex flex-row w-[243px] h-[48px] items-center justify-between">
            <p className="w-[24px] h-[24px] border border-black font-semibold text-[16px] flex items-center justify-center rounded-full">
              3
            </p>
            <p className="text-start text-black w-[211px] h-[48px] font-semibold text-[16px]">
              Compare and choose the best quotations
            </p>
          </div>
        </div>

        <form
          onSubmit={handleSubmit}
          className="w-[903px] h-[888px] flex flex-col"
        >
          <div className="flex flex-col mt-[24px]">
            <label
              className="block text-black font-medium text-[16px] mb-[12px]"
              htmlFor="requirements"
            >
              Detailed Requirements*
            </label>
            <input
              onChange={(e) => setTitle(e.target.value)}
              value={title}
              className="w-full h-[53px] p-[12px] border rounded-[12px] placeholder:w-[541px] placeholder:h-[131px] 
              placeholder:text-[14px] text-[14px] text-black resize-none bg-transparent border-[#CDCDCD]"
              placeholder="Name of the product you are looking for"
            />
            <input
              onChange={(e) => setDescription(e.currentTarget.value)}
              id="requirements"
              // rows={5}
              placeholder="Hi, I’m Interested in this product."
              value={description}
              className="w-full h-[223px] p-[12px] mt-3 border rounded-[12px] placeholder:w-[541px] placeholder:h-[131px] 
              placeholder:text-[14px] text-[14px] text-black resize-none bg-transparent border-[#CDCDCD]"
            />
          </div>
          <div className="flex flex-row items-center justify-between w-full h-[176px] mt-[24px]">
            <div className="w-[419px] h-[176px] border rounded-[12px] border-[#CDCDCD] flex items-center justify-center">
              <label className="m-8">
                <input
                  className="hidden "
                  type="radio"
                  value="recordRequirement"
                  checked={selectedOption === "recordRequirement"}
                  onChange={handleRadioBtnChange}
                />
                <SoundRecorder
                  width={200}
                  attachments={attachments}
                  selectedOption={selectedOption}
                />
              </label>

            </div>
            <span className="text-center w-[17px] h-[24px] text-[#959595] text-[16px]">
              or
            </span>
            <div className="w-[419px] h-[176px] rounded-[5px] border-2 border-dashed border-[#CDCDCD] flex flex-col items-center justify-center">
              {files.length === 0 && (
                <div className="flex flex-col items-center justify-center h-auto gap-y-[12px] w-auto">
                  <label>
                    <input
                      type="radio"
                      value="addImages"
                      checked={selectedOption === "addImages"}
                      onChange={handleRadioBtnChange}
                      className="hidden" // hide the radio button
                    />
                    <div
                      className="flex flex-col items-center justify-center cursor-pointer"
                      onClick={() => setSelectedOption("addImages")}
                    >
                      {EnquiryUploadSVG}
                      <span className="w-auto h-auto text-center text-black font-medium text-[16px] leading-[23px]">
                        Attach Supporting Files
                      </span>
                    </div>
                  </label>
                  <span className="w-auto h-auto text-center text-black font-medium text-[16px] leading-[23px] flex flex-col">
                    Attach supporting files to help the supplier to understand
                    your requirements better.
                  </span>
                </div>
              )}

              {selectedOption === "addImages" && (
                <div className=" h-auto rounded-[5px]">
                  <div className="flex flex-wrap gap-3">
                    {files.slice(0, 4).map((file, index) => (
                      <div
                        key={index}
                        className="w-auto border h-[55px] bg-white rounded-[5px] flex items-center justify-between pl-[19px]"
                      >
                        <div className="flex items-center gap-x-[15px]">
                          <img
                            className="w-[24px] h-[24px]"
                            src={ImgUploaded}
                            alt={`Product ${index}`}
                          />
                          <p className="w-[80px] h-[20px] font-medium text-start text-black text-[12px]">
                            {file.name}
                          </p>
                        </div>
                        <button onClick={() => handleDelete(index)}>
                          <div className="pr-[8px] pl-4">
                            {QuotationDeleteSVG}
                          </div>
                        </button>
                      </div>
                    ))}

                    {files.length < 4 && (
                      <div className="w-auto  rounded-[5px] py-[8px] px-[15px] flex items-center">
                        <form onSubmit={handleUpload} className="">
                          <div
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={handleDrop}
                          >
                            <input
                              multiple
                              type="file"
                              accept="image/*,application/pdf"
                              name="file"
                              onChange={handleFiles}
                              className="hidden"
                            />
                            <button
                              type="button"
                              onClick={() =>
                                document
                                  .querySelector("input[type=file]")
                                  .click()
                              }
                              className="flex items-center gap-x-[14px]"
                            >
                              <p
                                className="w-[35px] h-[35px] bg-[#FF6300]
                                   text-white flex items-center justify-center font-semibold text-[20px] rounded-[4px]"
                              >
                                {QuotationAddSVG}
                              </p>
                            </button>
                          </div>
                        </form>
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className="flex flex-row gap-4 mt-4 w-full overflow-x-auto">
                {uploadedFiles.map((file, index) => (
                  <div key={index} className="relative flex-shrink-0">
                    <img
                      src={file.url}
                      alt={`Uploaded ${index + 1}`}
                      className="w-[200px] h-[140px] rounded-[5px] border flex items-center justify-center"
                    />
                    <button
                      type="button"
                      onClick={() => handleDeleteFile(index)}
                      className="absolute top-2 right-2 p-1 bg-red-500 text-white w-[25px] h-[25px] flex items-center justify-center rounded-full"
                    >
                      &times;
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="w-[903px] h-[129px] mt-[24px] flex flex-row justify-between">
            <div className="w-[440px] h-[129px] flex flex-col gap-y-[12px]">
              <label
                className="w-[78px] h-[24px] font-medium text-[16px] text-black"
                htmlFor="quantity"
              >
                Quantity*
              </label>
              <div className="relative">
                <input
                  type="text"
                  id="quantity"
                  className="appearance-none border border-[#CDCDCD] rounded-[12px] w-full h-[48px] bg-transparent py-2 px-3 leading-tight focus:outline-none focus:shadow-outline placeholder:text-[16px] text-[16px]"
                  placeholder="Select or Enter Quantity"
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                />
                <select
                  className="absolute right-0 top-0 h-full bg-transparent border-l border-gray-300 py-2 px-3 focus:outline-none"
                  value={unit}
                  onChange={(e) => setUnit(e.target.value)}
                >
                  <option value="Unit">Unit</option>
                  <option value="Piece">Piece</option>
                  <option value="Kg">Kg</option>
                  <option value="Box">Box</option>
                </select>
              </div>
              <div className="flex gap-x-[12px]">
                {quantities.map((q) => (
                  <button
                    key={q}
                    className={`py-1 px-4 w-auto h-[33px] border rounded-[10px] ${quantity === q
                      ? "bg-[#FF6300] text-white"
                      : "bg-transparent text-[#FF6300] border-[#FF6300]"
                      } focus:outline-none`}
                    onClick={() => setQuantity(q)}
                  >
                    {q}
                  </button>
                ))}
              </div>
            </div>

            <div className="w-[440px] h-[129px] flex flex-col gap-y-[12px]">
              <label
                className="w-[214px] h-[24px] font-medium text-[16px] text-black"
                htmlFor="orderValue"
              >
                Approximate Order Value*
              </label>
              <div className="relative">
                <input
                  type="text"
                  id="orderValue"
                  className="w-full p-[12px] border rounded-[12px] placeholder:text-[14px] text-[14px] text-black bg-transparent border-[#CDCDCD]"
                  placeholder="Enter Price"
                  value={orderValue}
                  onChange={handleOrderValueChange} // Use the new handler
                />
                <select
                  className="absolute right-0 top-0 h-full bg-transparent border-l border-gray-300 py-2 px-3 focus:outline-none"
                  value={currency}
                  onChange={(e) => setCurrency(e.target.value)}
                >
                  <option value="Currency">Currency</option>
                  <option value="USD">USD</option>
                  <option value="EUR">EUR</option>
                  <option value="INR">INR</option>
                  {/* Add more currency options as needed */}
                </select>
              </div>
            </div>
          </div>

          <div className="mt-[24px] flex flex-row items-center justify-between h-[84px]">
            <div className="flex flex-col items-start justify-between h-[84px]">
              <label
                className="w-[120px] h-[24px] text-black font-medium text-[16px]"
                htmlFor="phoneNumber"
              >
                Phone Number
              </label>
              <input
                id="phoneNumber"
                type="tel"
                className="w-[419px] h-[48px] p-2 border border-[#CDCDCD] bg-transparent rounded-[12px] placeholder:text-[16px] text-[16px]"
                placeholder="Enter Phone Number"
                value={phoneNumber}
                onChange={handlePhoneNumberChange} // Use the new handler
              />
            </div>

            <span className="text-center w-[17px] h-[24px] text-[#959595] text-[16px]">
              or
            </span>
            <div className="flex flex-col items-start justify-between h-[84px]">
              <label
                className="w-[120px] h-[24px] text-black font-medium text-[16px]"
                htmlFor="email"
              >
                Email ID
              </label>
              <input
                id="email"
                type="email"
                className="w-[419px] h-[48px] bg-transparent p-2 border border-gray-300 rounded-[12px] placeholder:text-[16px] text-[16px]"
                placeholder="Enter Email ID"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>
          <div className="mt-[24px] flex items-center gap-x-[8px]">
            <input
              id="sendToMoreSuppliers"
              type="checkbox"
              className="bg-transparent rounded-[5px] w-[16px] h-[16px]"
              checked={sendToMoreSuppliers}
              onChange={(e) => setSendToMoreSuppliers(e.target.checked)}
            />
            <label
              htmlFor="sendToMoreSuppliers"
              className="text-black w-[818px] h-[24px] font-medium text-[16px]"
            >
              I'd like to send this RFQ to more suppliers, if I have not
              received 20 quotations within the next 48 hours.
            </label>
          </div>
          <div className="flex justify-center">
            <button
              onClick={handleSubmitButtonClick}
              type="submit"
              className="w-[216px] h-[48px] mt-[10px] text-white flex items-center justify-center font-semibold text-[16px] rounded-[10px] bg-[#FF6300]"
            >
              Send Requirements
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default QuotationForm;
